import { useParams, Link } from 'react-router-dom';
import materialsData from '../data/materials.json';
import PageBanner from '../components/PageBanner';
import PageTransition from '../components/PageTransition';
import useScrollTop from '../hooks/useScrollTop';
import '../styles/CategoryPage.css';

const CategoryPage = () => {
  useScrollTop();
  const { categoryId } = useParams();
  const category = materialsData.categories.find(cat => cat.id === categoryId);



  if (!category) {
    return (
      <div className="category-error">
        <h2>Category not found</h2>
        <Link to="/" className="back-link">Back to Home</Link>
      </div>
    );
  }

  return (
    <PageTransition>
      <div className="category-page">
      <PageBanner 
        title={category.name}
        description={category.description}
      />
      <div className="breadcrumbs">
        <div className="breadcrumbs-content">
          <Link to="/" className="breadcrumb-item">Home</Link>
          <span className="breadcrumb-separator">/</span>
          <span className="breadcrumb-current">{category.name}</span>
        </div>
      </div>

      <div className="products-container">
        <div className="products-grid-container">  
          <div className="products-grid">
            {category.materials.map((material) => (
              <div key={material.id} className="product-card">
                <div className="product-image">
                  <img src={material.imageUrl} alt={material.name} />
                </div>
                <div className="product-content">
                  <h3>{material.name}</h3>
                  <p>{material.description}</p>
                  <Link to={`/category/${categoryId}/product/${material.id}`}>
                    <button className="view-details-btn">View Details</button>
                  </Link>
                </div>
              </div>
            ))}
          </div>
      </div>
      </div>
    </div>
    </PageTransition>
  );
};export default CategoryPage;
